<template>
  <div>
         <stepheader :step="step"/>
        <div id="wizard2-p-0" role="tabpanel" aria-labelledby="wizard2-h-0" class="body current" aria-hidden="false" style="">
          <div class="row">
        
           <div class="col-12">
           <label class="form-label" for="vatnumber">Descrizione anomalia: <span class="tx-danger">*</span></label>
           
              <textarea  v-model="ticket.anomalia" class="form-control "></textarea>
            </div>
          </div>
     
          <buttons :buttons=step.buttons v-on:action="fireaction"></buttons>
											
 
  </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import axios from "axios";
export default {
  name: "anomalia",

  props: {
    step: {
      type: Object,
      required: true,
    },
    readonly: {
      type: Boolean,
      required: false,
      default: () => false,
    },
  ticket: {
      type: Object,
      required: false,
    },
    code: {
      type: String,
      required: false,
    },
  },
  data() {
    return {
     
    };
  },
  computed: {
   
  },
  components: {
   
  },
  mounted() {
  },
  methods: {
    fireaction:function(action,nextstep){
      switch(action){
        case "next":
           if(this.ticket.anomalia == ''){
         swal({
              title: "Errore di compilazione",
              text: "Anomalia obbligatoria",
              type: "error",
              showCancelButton: false,
              toast: false,
               timer: 2000, 
              showConfirmButton: false,
              position: "bottom-top",
            });

           }
           else{
  this.$emit("goto",nextstep);

           }
          break;
default:
   this.$emit("goto",nextstep);
  break;
      }

    },
   loaddata: function () {
    
    },

    authenticate:function(nextstep){

    }
  },
};
</script>